<template>
  <div>
    <div class="pc-block__title">
      {{ $t('pc.personal-data.title') }}
      <v-tooltip

        theme="pc-tooltip"
      >
        <icu-icon class=" pc-block__title-icon pc-edit"></icu-icon>
        <template #popper>
          <div class="popper-content">
            <div class="popper-content__text">
              {{ $t('pc.personal-data.tooltip-text') }}:
            </div>
            <div class="email">
              <a href="mailto:onboarding@icu.ua"><icu-icon class="pc-email" />onboarding@icu.ua</a>
            </div>
          </div>
        </template>
      </v-tooltip>
    </div>
    <div class="pc-list">
      <template v-for="(field, index) in Object.keys(fields)">
        <template v-if="!(field === 'photo_selfie' && userInfo.is_resident)">
          <div v-show="!(hasHiddenFields && index > 7)" :key="field" class="pc-row">
            <div class="pc-field__title">
              {{ $t(fields[field]) }}:
            </div>
            <div class="pc-field__value">
              <template v-if="Array.isArray(data[field])">
                <template v-if="data[field].length">

                  <span v-for="(data,index) in data[field]" :key="index">
                    <span v-if="index > 0">, </span>
                    <template v-if="field.includes('photo')">
                      <a
                        class="pc-field__link"
                        @click="showDoc(data)"
                      >
                        {{ data.name }}
                      </a>
                    </template>
                    <template v-else>
                      {{ data }}
                    </template>
                  </span>

                </template>
                <template v-else>
                  -
                </template>
              </template>
              <template v-else>
                {{ data[field] || '-' }}
              </template>
            </div>
          </div>
        </template>
      </template>
    </div>
    <pc-button
      :icon-left-name="hasHiddenFields? 'pc-visible' : 'pc-invisible'"
      variant="light"
      :disabled="false"
      @click="hasHiddenFields = !hasHiddenFields"
    >
      <template v-if="hasHiddenFields">
        {{ $t('pc.personal-data.show-all') }}
      </template>
      <template v-else>
        {{ $t('pc.personal-data.hide') }}
      </template>
    </pc-button>
  </div>
</template>


<script>
import IcuIcon from '@/components/common/IcuIcon'
import PcButton from '@/components/common/PcButton'
import {api} from '@/api/api'
import {mapGetters} from 'vuex'

export default {
  name: 'PcPersonalData',
  components: {PcButton, IcuIcon},
  data() {
    return {
      fields: {
        phone: 'application-form.step-1.phone',
        email: 'application-form.step-1.email',
        last_name: 'application-form.step-1.last-name',
        first_name: 'application-form.step-1.first-name',
        middle_name: 'application-form.step-1.middle-name',
        residency: 'application-form.step-1.tax-residency',
        inn: 'application-form.step-1.tax-id-number-short',
        backoffice_status: 'pc.personal-data.backoffice-status',
        birth_date: 'application-form.step-1.date-of-birth',
        birth_city: 'application-form.step-1.place-of-birth',
        citizenship: 'application-form.step-1.citizenship',
        photo_inn: 'application-form.step-1.photo-tax-id-number',
        employment_type: 'pc.personal-data.employment',
        employment_income_level: 'pc.personal-data.proceeds',
        passport: 'application-form.step-2.id-document-subtitle',
        passport_photo: 'application-form.step-2.photo-doc-short',
        registration_address: 'application-form.step-3.registration-address',
        living_address: 'application-form.step-3.living-address',
        photo_migrant_reference: 'application-form.step-3.migrant-certificate',
        photo_selfie: 'application-form.step-2.photo-selfie-label',
        fatca: 'FATCA',
        target: 'application-form.step-6.target',
        frequency: 'application-form.step-6.frequency'

      },
      hasHiddenFields: true,
      isTooltipShown: false,
      data: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  async mounted(){
    try {
      const {data} = await api.cabinet.personData()
      this.data = data
    }catch(err){
      console.log(err)
    }
  },
  methods: {
    async showDoc(data){
      const id = data.uuid
      const fileNameArray = data.name.split('.')
      const fileExtension = fileNameArray[fileNameArray.length -1]
      let mimeType = getMimeType(fileExtension)

      try{
        const res = await api.profile.downloadDoc(id)
        const blob = new Blob([res.data], { type: mimeType })
        const url = window.URL || window.webkitURL
        const link = url.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('href', link)
        if(!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          a.setAttribute('target', '_blank')
        }
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

      }catch(err){
        console.log(err)
        this.$toast.error(this.$t('notifications.something-went-wrong'))
      }

      function getMimeType(str) {
        if (str === 'pdf') {
          return 'application/pdf'
        }
        if (str === 'jpg') {
          return 'image/jpeg'
        }
        return 'image/' + str
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/theme.scss";

.pc-list {
  padding-bottom: 48px;
}
.pc-row {
  display: flex;
  font-size: 15px;
  justify-content: space-between;
  padding-bottom: 21px;

  &:last-child {
    padding-bottom: 0;
  }
}

.pc-field__title {
  flex-shrink: 0;
  flex-basis: 45%;
  color: $light-text;
  font-weight: 400;
}
.pc-field__value {
  flex-basis: 55%;
  padding-left: 15px;
  font-weight: 700;
  word-wrap: break-word;

  span {
    word-break: break-all;
  }
}

.popper-content {
  max-width: 288px;
  font-size: 12px;

  &__text {
    color: $black;
  }
}

.email {
  padding-top: 15px;
  font-size: 12px;
  font-weight: 700;
  a {
    display: flex;
    align-items: center;
  }
  .pc-email {
    margin-right: 12px;
  }
}

.pc-field__link {
  font-weight: 400;
  color: #295770;
  text-decoration: underline;
  cursor: pointer;
}

</style>
